var React = require('react');

function Reply (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9 17L4 12L9 7","stroke":"#130A09","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M20 18V16C20 14.9391 19.5786 13.9217 18.8284 13.1716C18.0783 12.4214 17.0609 12 16 12H4","stroke":"#130A09","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Reply.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Reply;

Reply.default = Reply;
